import css3 from "./css3.svg";
import express from "./express.svg";
import jquery from "./jquery.svg";
import laravel from "./laravel.svg";
import mongodb from "./mongodb.svg";
import mongoose from "./mongoose.svg";
import node from "./node.svg";
import php from "./php.svg";
import pug from "./pug.svg";
import react from "./react.svg";
import sass from "./sass.svg";
import styled_components from "./styled-components.svg";

const tech_icons = {
  css3,
  node,
  mongodb,
  jquery,
  express,
  pug,
  react,
  sass,
  styled_components,
  mongoose,
  laravel,
  php,
};

export default tech_icons;
